import { MMButton } from '@components'
import { copyTextToClipboard, tr } from 'mmfintech-commons'
import { QRCodeSVG } from 'qrcode.react'
import { toast } from 'react-hot-toast'

import PixLogo from '../../../assets/icons/pix-logo.svg'
import { QrCodeWrapper } from './PreviewPix.styled'

export const PreviewPix = ({ value }) => {
  return (
    <QrCodeWrapper>
      <p className='text-center'>
        <img src={PixLogo} alt='' />
      </p>
      <p className='text-center'>
        {tr(
          'FRONTEND.DEPOSIT.RESULT.QR_CODE',
          'Open the app with your registered PIX key, choose Pay with Pix and scan the QR Code or copy and paste the code.'
        )}
      </p>
      <p className='text-center code'>
        <QRCodeSVG value={value} size={256} />
      </p>
      <p className='text-center'>
        <MMButton
          type='button'
          variant='primary'
          caption={tr('FRONTEND.DEPOSIT.RESULT.COPY_CODE', 'Copy code')}
          onClick={() => {
            copyTextToClipboard(value, () => {
              toast.remove()
              toast.success(tr('FRONTEND.DEPOSIT.RESULT.QR_CODE_COPIED', 'Code is copied to clipboard').toString())
            })
          }}
          fullWidth
        />
      </p>
    </QrCodeWrapper>
  )
}
